import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../../../pages/sidebar/SidebarCom";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  StyledBoxOutlet,
  StyledLayout,
  StyledLayoutContent,
  StyledNavbar,
} from "./style";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../navbar/navbar";
import { cookie } from "../../../cookies/cookies";
import { PROFILE_DETAILS } from "../../../actions/AuthActions";
import { ADD_VIRTUAL_LOCKER } from "../../../actions/AddressActions";
import CompleteProfileModal from "../../modals/complete-profile/CompleteProfile";

const Layout = () => {
  const isAuthenticated = cookie.get("token");

  const dispatch = useDispatch();
  const location = useLocation();
  const profileDetail = useSelector((state) => state?.auth?.profileDetails);
  const isAdmin = profileDetail?.user_type === "admin";
  const isPersonalShopper =
    (profileDetail?.user_type || cookie.get("user_type")) === "personal_shopper";
  const isProfileCompleted = useSelector(
    (state) => state.auth?.profileDetails?.is_profile_completed
  );
  const isProfileLoading = useSelector((state) => state.auth?.isMeLoading);
  const [open, setOpen] = useState(false);
  const lockerFetchedRef = useRef(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch({ type: PROFILE_DETAILS });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated || isAdmin || !profileDetail?.user_type || lockerFetchedRef.current) {
      return;
    }
    lockerFetchedRef.current = true;
    dispatch({ type: ADD_VIRTUAL_LOCKER });
  }, [dispatch, isAuthenticated, isAdmin, profileDetail?.user_type]);

  useEffect(() => {
    const isCompletingProfile =
      location.pathname === "/dashboard/profile" && location.state?.editProfile;

    if (
      !isProfileCompleted &&
      !isProfileLoading &&
      !isAdmin &&
      !isPersonalShopper &&
      !isCompletingProfile
    ) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [
    isProfileCompleted,
    isProfileLoading,
    isAdmin,
    isPersonalShopper,
    location.pathname,
    location.state?.editProfile,
  ]);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (
    (location.pathname === "/" || location.pathname === "") &&
    isAuthenticated
  ) {
    return (
      <Navigate to={isAdmin ? "/admin/dashboard" : "/dashboard"} replace />
    );
  }

  return (
    <StyledLayout>
      <StyledLayoutContent>
        <Sidebar />
        <StyledNavbar>
          <Navbar />
          <StyledBoxOutlet>
            <Outlet />
          </StyledBoxOutlet>
        </StyledNavbar>
      </StyledLayoutContent>
      {open && <CompleteProfileModal open={open} handleClose={() => {}} />}
    </StyledLayout>
  );
};

export default Layout;
